import React, { Component } from 'react'
import PropTypes from 'prop-types'

const ANIMATION_STATE = {
    OPEN: 'open',
    CLOSE: 'close',
}

const HEIGHT_AUTO = 'auto'

export default class Collapse extends Component {
    static propTypes = {
        children: PropTypes.oneOfType([PropTypes.array, PropTypes.element]).isRequired,
        duration: PropTypes.number,
        dynamicTimeHeight: PropTypes.number,
        easing: PropTypes.string,
        expand: PropTypes.bool.isRequired,
        nested: PropTypes.bool,
        noAnimateId: PropTypes.oneOfType([PropTypes.number, PropTypes.string]), // eslint-disable-line react/no-unused-prop-types
        onAnimationEnd: PropTypes.func,
        onAnimationStart: PropTypes.func, // eslint-disable-line react/no-unused-prop-types
        unMountOnClose: PropTypes.bool,
    }

    static defaultProps = {
        duration: 2000,
        dynamicTimeHeight: null,
        easing: 'linear',
        nested: false,
        noAnimateId: null,
        onAnimationEnd: () => {},
        onAnimationStart: () => {},
        unMountOnClose: false,
    }

    constructor(props) {
        super(props)

        this.state = {
            height: props.expand ? HEIGHT_AUTO : 0,
            actualHeight: 0,
            noAnimate: false,
            showChildren: true,
        }
    }

    componentDidUpdate(prevProps) {
        const { nested } = prevProps

        if (!nested) this.changePropsCallback(prevProps, this.props)
        else
            requestAnimationFrame(() => {
                this.changePropsCallback(prevProps, this.props)
            })
    }

    onTransitionEnd = (_e) => {
        if (this._content !== _e.target) return

        const { nested, onAnimationEnd, unMountOnClose } = this.props
        const { height } = this.state

        if (nested) {
            this.setState({
                height: height === 0 ? 0 : HEIGHT_AUTO,
                actualHeight: 0,
            })
        }

        if (unMountOnClose && height === 0) {
            this.setState({
                showChildren: false,
            })
        }

        onAnimationEnd(height === 0 ? ANIMATION_STATE.CLOSE : ANIMATION_STATE.OPEN, height, _e.elapsedTime * 1000)
    }

    changePropsCallback = (actProps, nextProps) => {
        const { expand, noAnimateId, onAnimationStart, unMountOnClose } = actProps
        const { expand: expandNext, noAnimateId: noAnimateIdNext } = nextProps

        // you can't stop animation, when noAnimateId is null
        // no animate is for change content purpose (e.g. blocks in one module - in first tab is block open and in second is block close)
        const noAnimate = noAnimateId !== null && noAnimateIdNext !== null && noAnimateId !== noAnimateIdNext

        const actualHeight = (this._content && this._content.scrollHeight) || 0

        // OPEN component
        if (!expand && expandNext) {
            if (unMountOnClose) {
                this.setState({ showChildren: true }, () => {
                    this.setState({ height: this._content.scrollHeight, actualHeight, noAnimate })

                    // call callback for animation start
                    if (!noAnimate) onAnimationStart(ANIMATION_STATE.OPEN, 0)
                })
            } else {
                this.setState({ height: this._content.scrollHeight, actualHeight, noAnimate })

                // call callback for animation start
                if (!noAnimate) onAnimationStart(ANIMATION_STATE.OPEN, 0)
            }
        }

        // CLOSE component
        if (expand && !expandNext) {
            // first closing sacrifice one render for real height of element
            if (this.state.height === HEIGHT_AUTO) {
                this.setState({ height: actualHeight }, () => {
                    // because render could be really quick
                    requestAnimationFrame(() => {
                        this.setState({ height: 0, actualHeight, noAnimate })
                    })
                })
            } else {
                this.setState({ height: 0, noAnimate })
            }

            // call callback for animation start
            if (!noAnimate) onAnimationStart(ANIMATION_STATE.CLOSE, actualHeight)
        }
    }

    render() {
        const { expand, children, duration, dynamicTimeHeight, easing } = this.props
        const { height, actualHeight, noAnimate, showChildren } = this.state

        // if noAnimate, change transition duration to 0
        let realDuration = noAnimate ? 0 : duration

        // if dynamicTimeHeight is set, animation duration is in ratio to dynamicTimeHeight
        if (dynamicTimeHeight && actualHeight !== 0) realDuration *= actualHeight / dynamicTimeHeight

        return (
            <div className={'general-collapse-component'} style={{ overflow: expand ? 'initial' : 'hidden' }}>
                <div
                    ref={(r) => (this._content = r)}
                    style={{
                        transition: `height ${realDuration}ms ${easing}`,
                        height,
                    }}
                    onTransitionEnd={this.onTransitionEnd}
                >
                    {showChildren ? children : null}
                </div>
            </div>
        )
    }
}
